// Event data dump — confirmed entries are shown in full, others render as "To be announced soon"
// Locations are fully addressable so a clean Google Maps link can be generated.

import { map } from "zod/v4-mini";

export const events = [
  {
    id: 1,
    date: "4 Jun 2026",
    day: "Thursday",
    session: "Morning",
    time: "7:00 AM – 9:30 AM",
    topic: "Sundarakanda Parayanam",
    venueName: "South London Sanathan Mandir",
    address: "108 Chipstead Valley Rd, Coulsdon, CR5 3BA",
    mapLink: "https://maps.app.goo.gl/4sFHGiXrwPUMRSDZ6",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 2,
    date: "4 Jun 2026",
    day: "Thursday",
    session: "Evening",
    time: "6:00 PM – 8:00 PM",
    topic: "Ramayana's Relevance in the Modern World",
    venueName: "South London Sanathan Mandir",
    address: "108 Chipstead Valley Rd, Coulsdon, CR5 3BA",
    mapLink: "https://maps.app.goo.gl/4sFHGiXrwPUMRSDZ6",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 3,
    date: "5 Jun 2026",
    day: "Friday",
    session: "Morning",
    time: "7:00 AM – 9:30 AM",
    topic: "Sundarakanda Parayanam",
    venueName: "South London Sanathan Mandir",
    address: "108 Chipstead Valley Rd, Coulsdon, CR5 3BA",
    mapLink: "https://maps.app.goo.gl/4sFHGiXrwPUMRSDZ6",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 4,
    date: "5 Jun 2026",
    day: "Friday",
    session: "Evening",
    time: "6:30 PM – 8:30 PM",
    topic: "Leadership in Ramayana",
    venueName: "Raja Rajeshwari Amman Temple",
    address: "4 Dell Ln, Stoneleigh, Epsom KT17 2NE",
    mapLink: "https://maps.app.goo.gl/EanoM3vhJUVWFH5RA",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 5,
    date: "6 Jun 2026",
    day: "Saturday",
    session: "Morning",
    time: "7:00 AM – 8:00 AM",
    topic: "Sundarakanda Parayanam Sampoornam",
    venueName: "South London Sanathan Mandir",
    address: "108 Chipstead Valley Rd, Coulsdon, CR5 3BA",
    mapLink: "https://maps.app.goo.gl/4sFHGiXrwPUMRSDZ6",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 6,
    date: "6 Jun 2026",
    day: "Saturday",
    session: "Late Morning",
    time: "11:00 AM – 1:00 PM",
    topic: "Dhruva Charithram",
    venueName: "Amersham Satsang",
    address: "Amersham HP15",
    mapLink: "https://maps.app.goo.gl/4KBnTNPufs2fqC237",
    contactName: "Venkataraman VC",
    contactPhone: "+44 7525218187",
    confirmed: true,
  },
  {
    id: 7,
    date: "6 Jun 2026",
    day: "Saturday",
    session: "Evening",
    time: "6:00 PM – 8:00 PM",
    topic: "Sita Kalyanam",
    venueName: "Shelly Community Farm",
    address: "Monkspath, Solihull, Birmingham B90 4EH",
    mapLink: "https://maps.app.goo.gl/WyZ9zdiPqLxHTqzFA",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 8,
    date: "7 Jun 2026",
    day: "Sunday",
    session: "Afternoon",
    time: "11:30 AM – 1:00 PM",
    topic: "Sabari Moksham - Harikatha",
    venueName: "Mitra Sewa London",
    address: "The Mount Stewart Schools, Carlisle Gardens, Mount Stewart Avenue, Kenton, Harrow, HA3 0JX",
    mapLink: "https://maps.app.goo.gl/LFSniVGXFt18Vr2u5",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 9,
    date: "7 Jun 2026",
    day: "Sunday",
    session: "Evening",
    time: "5:30 PM – 7:00 PM",
    topic: "Fundamentals of Sanathana Dharma",
    venueName: "VHP Temple",
    address: "43 Cleveland Rd, Ilford IG1 1EE",
    mapLink: "https://maps.app.goo.gl/BSWGYaYSZEGiNDze6",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 10,
    date: "8 Jun 2026",
    day: "Monday",
    session: "Evening",
    time: "6:30 PM – 8:00 PM",
    topic: "Sundarakandam",
    venueName: "Colchester Satsang",
    address: "Colchester CO6",
    contactName: "Shri Karthik",
    contactPhone: "+44 7438629436",
    confirmed: true,
  },
  {
    id: 11,
    date: "9 Jun 2026",
    day: "Tuesday",
    session: "Evening",
    time: "6:30 PM – 8:00 PM",
    topic: "Hanuman Chalisa",
    venueName: "Chelmsford Shri Sanatana Shakti Mandir",
    address: "37 Beehive Ln, Great Baddow, Chelmsford CM2 9TQ, United Kingdom",
    mapLink: "https://maps.app.goo.gl/Qbky9444zAZzKTLU7",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 12,
    date: "10 Jun 2026",
    day: "Wednesday",
    session: "Evening",
    time: "6:30 PM – 8:00 PM",
    topic: "Sudhama Charithram",
    venueName: "Reading Amman Temple",
    address: "117–119 Oxford Road, Reading RG1 7UH",
    mapLink: "https://maps.app.goo.gl/57nmBwENjsr74jmE7",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 13,
    date: "11 Jun 2026",
    day: "Thursday",
    session: "Evening",
    time: "6:45 PM – 8:30 PM",
    topic: "Hanuman chalisa",
    venueName: "Oxford Hindu Mandir & Community Centre",
    address: "Court Farm Place, Marsh Lane, Oxford, OX3 0NQ",
    mapLink: "https://maps.app.goo.gl/mMz1Tg1Rb684yaL49",
    contactName: "Swetha Sundaram",
    contactPhone: "+44 (0) 7899086630",
    confirmed: true,
  },
  {
    id: 14,
    date: "12 Jun 2026",
    day: "Friday",
    session: "Evening",
    time: "5:30 PM – 7:00 PM",
    topic: "Hanuman Chalisa",
    venueName: "Shree Hanuman Temple - Salangpur Dham Leicester",
    address: "299 Melton Rd, Leicester LE4 7AN, United Kingdom",
    mapLink: "https://maps.app.goo.gl/SSGG9MLSvgbqQpik7",
    contactName: "Sumathi Ji",
    contactPhone: "+44 7843295458",
    confirmed: true,
  },
  {
    id: 15,
    date: "13 Jun 2026",
    day: "Saturday",
    session: "Morning",
    time: "10:00 AM – 12:00 PM",
    topic: "Sundara Kandam",
    venueName: "Leeds Hindu Mandir",
    address: "36 Alexandra Rd, Burley, Leeds LS6 1RF, United Kingdom",
    mapLink: "https://maps.app.goo.gl/UxjvUkPDfcwnPYgGA",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 16,
    date: "13 Jun 2026",
    day: "Saturday",
    session: "Evening",
    time: "6:30 PM – 8:00 PM",
    topic: "Bharatha's Bakthi & Rama's Dharma - A Dialogue (Hari Katha)",
    venueName: "Oversdale Community Centre",
    address: "Buchanan Road, Rugby CV22 6AZ",
    mapLink: "https://maps.app.goo.gl/TCR3owjHiNVbvFdp9",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 17,
    date: "14 Jun 2026",
    day: "Sunday",
    session: "Morning",
    time: "11:00 AM – 12:30 PM",
    topic: "Women power in Sanatan Dharma",
    venueName: "Waterworks house , Longford, Gloucester, GL29GF",
    address: "Longford Ln, Innsworth, Gloucester GL2 9GF, UK",
    mapLink: "https://maps.app.goo.gl/8NkZd7bXiTyuxvAa8",
    contactName: "Dr SS Kannan",
    contactPhone: "07727072540",
    confirmed: true,
  },
  {
    id: 18,
    date: "14 Jun 2026",
    day: "Sunday",
    session: "Evening",
    time: "6:00 PM – 7:30 PM",
    topic: "Sundarakandam",
    venueName: "Sri Siddhi Vinayak Mandir",
    address: "Ferry Meadows Cl, Broughton, Milton Keynes MK10 9QY, United Kingdom",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 19,
    date: "15 Jun 2026",
    day: "Monday",
    session: "Evening",
    time: "7:00 PM – 8:30 PM",
    topic: "Navavidha Bakthi",
    venueName: "Salisbury SP5",
    address: "Salisbury SP5",
    contactName: "Radha Ranganathan Ji",
    contactPhone: "+44 7912699306",
    confirmed: true,
  },
  {
    id: 20,
    date: "16 Jun 2026",
    day: "Tuesday",
    session: "Morning",
    time: "12:00 PM – 2:00 PM",
    topic: "Maryadha Purushuotham - SriRam",
    venueName: "Shree Ram Mandir",
    address: "22 King St, Southall UB2 4DA, United Kingdom",
    mapLink: "https://maps.app.goo.gl/5bMwAXDPfKrJWtDx5",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
  {
    id: 21,
    date: "17 Jun 2026",
    day: "Wednesday",
    session: "Evening",
    time: "7:30 PM – 9:00 PM",
    topic: "Hanuman Chalisa",
    venueName: "Shree Ram Mandir (SSPC Birmingham UK)",
    address: "8 Walford Rd, Sparkbrook, Birmingham B11 1NR, United Kingdom",
    mapLink: "https://maps.app.goo.gl/c6MJepwQSza94Do57",
    contactName: null,
    contactPhone: null,
    confirmed: true,
  },
];

export const buildMapsLink = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
